export const RESUME_ABOUT_ME_EDIT_MODAL_NAME = 'resumeAboutMeEdit';
